// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
export var JUPYTER_WIDGETS_VERSION = '1.2.0';
export var PROTOCOL_VERSION = '2.0.0';
